import styled from "styled-components";
import CenterLead from "../center-lead/center-lead.component";

const CTAContainer = styled(CenterLead)`
  padding-top: 200px;
  padding-bottom: 200px;
`;

export { CTAContainer };
